import { decode } from "he";

/**
 * Extracts the inner content of a fenced markdown code block, if present.
 * Falls back to returning the original content when no fence is found.
 */
export const extractTableContent = (content) => {
  const codeBlockMatch = content.match(/```(?:markdown)?\s*([\s\S]*?)```/);
  return codeBlockMatch ? codeBlockMatch[1].trim() : content;
};

/**
 * Serializes `{ headers, rows }` table data back into CSV text (RFC-4180
 * quoting). Used when a table was rendered from the structured backend
 * payload but the user downloads it as CSV.
 */
export const tableDataToCSV = ({ headers, rows }) => {
  const quote = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  return [headers, ...rows].map((r) => r.map(quote).join(",")).join("\n");
};

/**
 * Parses a CSV string into `{ headers, rows }`. Supports simple quoted fields
 * (commas inside quotes are not treated as separators).
 */
export const parseCSVToTable = (csvContent) => {
  const lines = decode(csvContent.trim()).split("\n");
  if (lines.length === 0) return null;

  const headers = lines[0].split(",").map((h) => h.replace(/"/g, "").trim());

  const rows = lines.slice(1).map((line) => {
    const row = [];
    let currentField = "";
    let insideQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      if (char === '"') {
        insideQuotes = !insideQuotes;
      } else if (char === "," && !insideQuotes) {
        row.push(currentField.trim());
        currentField = "";
      } else {
        currentField += char;
      }
    }
    row.push(currentField.trim());

    return row;
  });

  return { headers, rows };
};
